import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcClose16Icon, IcNewChatIcon } from '@gem/icons';
import { AddKeyPressHandler } from '@gem/keyboard-handler';
import { FAB, IconView } from '@gem/ui-kit';

import { MiniatureMessage } from 'APP/main/ChatView/components/MiniatureMessage/MiniatureMessage';

import { useEditMessagePresenter } from './EditMessage.presenter';
import styles from './EditMessage.styles.m.css';

interface IEditMessageProps {
  className?: string;
}

export const EditMessage: FC<IEditMessageProps> = observer(({ className }) => {
  const presenter = useEditMessagePresenter();

  if (!presenter.message) {
    return null;
  }

  return (
    <div className={className}>
      <AddKeyPressHandler onEsc={presenter.cancel} />
      <IconView
        Icon={IcNewChatIcon}
        className={styles.icon}
      />
      <div className={styles.miniature}>
        <MiniatureMessage
          titleClassName={styles.miniatureTitle}
          textClassName={styles.miniatureText}
          iconClassName={styles.miniatureIcon}
          message={presenter.message}
          title={<p className={styles.title}>{presenter.message?.avatarTitle || ''}</p>}
        />
      </div>

      <FAB
        Icon={IcClose16Icon}
        size="10"
        iconSize="0"
        theme="12"
        onClick={presenter.cancel}
        className={styles.remove}
      />
    </div>
  );
});
